import { Injectable, inject } from "@angular/core";
import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {SharedPermissionsService} from "@shared/services/shared-permissions.service";
import {tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SharedPermissionGuard {
  private _permissionsService = inject(SharedPermissionsService);
  private _router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot) {
    return this._permissionsService.hasPermissions$(route.data['permissions']).pipe(
      tap(hasAccess => {
        if (!hasAccess) {
          this._router.navigate(route.data['redirectTo'])
        }
      })
    )
  }
}
